"use strict";
// @flow
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const AppProvider_1 = require("./AppProvider");
class EightBaseAppProvider extends react_1.default.Component {
    componentDidMount() {
        // tslint:disable
        console.error('DEPRECATION WARNING: EightBaseAppProvider has been renamed to AppProvider.');
        // tslint:enabe
    }
    render() {
        return react_1.default.createElement(AppProvider_1.AppProvider, Object.assign({}, this.props));
    }
}
exports.EightBaseAppProvider = EightBaseAppProvider;
//# sourceMappingURL=EightBaseAppProvider.__deprecated.js.map